module.exports = __webpack_public_path__ + "static/media/Swampert_gaussian2.9fd389b7.png";